import { reactive, computed } from '@vue/composition-api'
import * as _ from 'lodash'
import { formatDateKanji } from '@/util/common'

export const ContractAssignLicenseForPackage = (props, context) => {
  const store = context.root.$store
  const { contract } = store.state

  const data = reactive({
    users: computed(() => store.getters['users/sortedLoginIdAndAuth']),
    product: store.state.contractPack.selectProduct
  })

  const state = reactive({
    checkBox: [],
    cancelLists: [],
    isCancel: (id) => _.includes(state.cancelLists, id),
    max: computed(() => data.product.license_number),
    isMax: computed(() => state.checkBox.length >= state.max),
    canSubmit: computed(() => state.checkBox.length > state.max),
    searchKeyword: '',
    searchKeywordCommit: '',
    accountIsMax: computed(() => contract.account_number >= contract.account_number_max),
    search: () => {
      state.searchKeywordCommit = state.searchKeyword.replace(/[\s　]/g, '')
    },
    filterdUser: computed(() => {
      return _.filter(data.users, user => {
        return !state.searchKeywordCommit || user.name.replace(/[\s　]/g, '').indexOf(state.searchKeywordCommit) > -1
      })
    }),
    getUsingUser: computed(() => {
      const code = data.product.code
      return _.map(_.filter(data.users, user => {
        return _.includes(_.map(user.products, product => product.code), code)
      }), user => {
        const product = _.find(user.products, product => product.code === code)

        return {
          id: user.id,
          name: user.name,
          release_flag: product.release_flag,
          period_end: product.period_end
        }
      })
    })
  })

  const action = reactive({
    changeCheckbox: (event) => {
      event.preventDefault()
      const { value, checked } = event.target
      const valueInt = parseInt(value)
      if (checked) {
        // cancelListsの数が足りなければ追加する
        const continueNum = state.max - data.product.cancel_license_number
        if (state.checkBox.length - state.cancelLists.length > continueNum) {
          state.cancelLists.push(valueInt)
        }
      } else {
        // cancelListsから削除する
        state.cancelLists = _.without(state.cancelLists, valueInt)
      }
    },
    beforeChange: (id, event) => {
      if (state.checkBox.length >= state.max) {
        // checkboxの配列に存在する場合はチェック済み=チェックを外す処理
        if (!_.includes(state.checkBox, id)) {
          // 契約数以上にチェックを入れれないようにイベントを消す
          event.preventDefault()
        }
      }
    },
    submit: () => {
      // use：商品コードの割当有無　無=0、有=1、有（次年度解約予定）=2

      // 変更前の付与状態を作成
      const beforeLists = _.map(state.getUsingUser, user => {
        return {
          id: user.id,
          use: user.release_flag === 1 ? 2 : 1
        }
      })

      // 変更後の付与状態を作成
      const afterLists = _.map(state.checkBox, check => {
        return {
          id: check,
          use: _.includes(state.cancelLists, check) ? 2 : 1
        }
      })

      // usersのリスト分まわし、変更差分を取り出す
      const userLists = _.map(data.users, user => {
        return { id: user.id, use: null }
      })

      const changed = []
      _.each(userLists, user => {
        const before = _.find(beforeLists, b => b.id === user.id)
        const after = _.find(afterLists, a => a.id === user.id)
        if (after && !before) {
          // 変更後だけにあれば追加
          changed.push(after)
        } else if (after && before) {
          // 両方にあれば、useの値が変わっているか確認し変更があればafterのものを追加
          if (before.use !== after.use) {
            changed.push(after)
          }
          // 変更がない場合は追加しない
        } else if (before) {
          // 変更前にだけデータがある場合は、削除データを追加
          before.use = 0
          changed.push(before)
        }
      })

      // API用に値を加工する
      const params = _.map(changed, list => {
        return {
          id: list.id,
          products: [
            {
              code: data.product.code,
              use: list.use
            }
          ]
        }
      })

      context.emit('submit', params)
    }
  })

  // checkboxに初期値を与える
  const checkLists = _.map(state.getUsingUser, user => user.id)
  state.checkBox = checkLists

  // 解除フラグがついているユーザーIDをchancelListsに初期値として渡す
  const cancelLists = _.map(_.filter(state.getUsingUser, user => user.release_flag === 1), user => user.id)
  state.cancelLists = cancelLists

  const close = () => {
    context.emit('close')
  }

  const openCreate = () => {
    context.emit('create')
  }

  return {
    data,
    state,
    action,
    close,
    openCreate,
    formatDateKanji
  }
}
